/*
 * קבוצות שליטה.
 *
 * **הן חיות מחוץ לסימולציה, וזו החלטה ולא קיצור דרך.** בחירה אינה חלק ממצב
 * המשחק — שני שחקנים ברשת בוחרים יחידות שונות באותו טיק, וה-hash חייב להישאר
 * זהה. לכן הקבוצות הן מצב ממשק טהור, בדיוק כמו הבחירה עצמה.
 *
 * מכאן נובעת התכונה החשובה: **הקבוצה מסננת מתים בזמן השליפה, לא בזמן המוות.**
 * אין למי להאזין — הסימולציה לא מדווחת לממשק מי מת — ולכן אנחנו לא מחזיקים
 * רשימה "נכונה" אלא כוונה ("הכוח שסימנתי"), ומצטלבים אותה עם החיים כשמשתמשים בה.
 */

/** כמה קבוצות. שלוש הן מה שנכנס בסרגל טלפון בלי לגזול משבצת מפעולה אמיתית. */
export const GROUP_COUNT = 3;

export type ControlGroups = readonly (readonly number[])[];

export function createGroups(): ControlGroups {
    return Array.from({ length: GROUP_COUNT }, () => [] as readonly number[]);
}

function inRange(index: number): boolean {
    return Number.isInteger(index) && index >= 0 && index < GROUP_COUNT;
}

/**
 * משייך את הבחירה הנוכחית לקבוצה. שיוך **דורס** — כמו ב-RA2, ואין "הוסף
 * לקבוצה" נפרד: מי שרוצה להוסיף בונה את הבחירה ומשייך מחדש.
 *
 * המזהים נשמרים ממוינים, כי הם נוסעים משם היישר לפקודות שהסימולציה ממיינת
 * בכל מקרה — וכך "אותה קבוצה" היא גם אותה רשימה בהשוואה.
 */
export function assignGroup(
    groups: ControlGroups,
    index: number,
    ids: Iterable<number>,
): ControlGroups {
    if (!inRange(index)) return groups;
    const unique = [...new Set(ids)].sort((a, b) => a - b);
    return groups.map((group, i) => (i === index ? unique : group));
}

/**
 * שולף קבוצה — רק המזהים שעדיין חיים.
 *
 * `living` הוא מה שקיים במצב **עכשיו**. קבוצה שכל חבריה מתו מחזירה רשימה ריקה,
 * ואז הקורא לא משנה את הבחירה: "שליפה של קבוצה מתה" שמוחקת את מה שביד היא
 * בדיוק סוג הבאג שאי אפשר לתקן באמצע קרב.
 */
export function recallGroup(
    groups: ControlGroups,
    index: number,
    living: ReadonlySet<number>,
): readonly number[] {
    if (!inRange(index)) return [];
    return (groups[index] ?? []).filter((id) => living.has(id));
}

/** כמה יחידות חיות בקבוצה — התווית שמוצגת על הכפתור. */
export function groupSize(
    groups: ControlGroups,
    index: number,
    living: ReadonlySet<number>,
): number {
    return recallGroup(groups, index, living).length;
}
